import React from 'react';
import { Collapse } from 'antd';
import { Hero, HeroContents, HeroBadge, HeroTitle, HeroDescription, DownIcon, } from '../HowItWorks/styled';
import down from '../../images/down.svg';
import Header from '../../layout/Header';
import { CenteredSectionSmall, PageContents } from '../Home/styled';
const Panel = Collapse.Panel;

const FaqRoot: React.FC<{ faq: Array<any> }> = ({ faq }) => {
	return (
		<React.Fragment>
			<Hero>
				<Header />
				<HeroContents>
					<HeroBadge>FAQs</HeroBadge>
					<HeroTitle>DeReader Support</HeroTitle>
					<HeroDescription>We have answered some commonly asked questions below. Feel free to contact us if you have any other questions.</HeroDescription>
					<DownIcon src={down} alt="Scroll Down" />
				</HeroContents>
			</Hero>
			<PageContents>
				<CenteredSectionSmall>
					<Collapse defaultActiveKey={['0']}>
						{faq.map((f) => {
							return (
								<Panel header={f.question} key={f.key}>
									<p>{f.answer}</p>
								</Panel>
							);
						})}
					</Collapse>
				</CenteredSectionSmall>
			</PageContents>
		</React.Fragment>
	);
}

export default FaqRoot;
